self.__BUILD_MANIFEST = {
  "/404": [
    "static/chunks/26_icj5p-5b5w.js"
  ],
  "/[languageMarket]/[[...slug]]": [
    "static/chunks/04dsnse9wwl6l.js"
  ],
  "/[languageMarket]/confirm-subscriber": [
    "static/chunks/1-26uhc6l7ymm.js"
  ],
  "/[languageMarket]/order-tracking": [
    "static/chunks/1etwcmob9lzdd.js"
  ],
  "/[languageMarket]/subscription": [
    "static/chunks/3mcjxmyqj8s9o.js"
  ],
  "/[languageMarket]/unsubscribe": [
    "static/chunks/3u46efu872x1o.js"
  ],
  "/_error": [
    "static/chunks/1yxsad7rd8_ew.js"
  ],
  "/_static/[device]/[searchParams]/[languageMarket]/[[...slug]]": [
    "static/chunks/07odq3t-tf3qh.js"
  ],
  "/auth-callback": [
    "static/chunks/3vvivlkc93xbi.js"
  ],
  "__rewrites": {
    "afterFiles": [],
    "beforeFiles": [],
    "fallback": []
  },
  "sortedPages": [
    "/404",
    "/_app",
    "/_error",
    "/_static/[device]/[searchParams]/[languageMarket]/[[...slug]]",
    "/api/__tests__/account/wishlists/count.spec",
    "/api/__tests__/account/wishlists/items/add.spec",
    "/api/__tests__/account/wishlists/items/remove.spec",
    "/api/__tests__/account/wishlists/items.spec",
    "/api/__tests__/checkout/selection.spec",
    "/api/account/addresses",
    "/api/account/notify-if-back",
    "/api/account/orders",
    "/api/account/orders/index.spec",
    "/api/account/privacy-portal-url",
    "/api/account/profile",
    "/api/account/receipts",
    "/api/account/receipts/[itemId].spec",
    "/api/account/receipts/index.spec",
    "/api/account/receipts/[itemId]",
    "/api/account/settings",
    "/api/account/staff-card",
    "/api/account/staff-card/delete",
    "/api/account/wishlists",
    "/api/account/wishlists/[id]/count",
    "/api/account/wishlists/[id]/items",
    "/api/account/wishlists/[id]/items/add",
    "/api/account/wishlists/[id]/items/[itemId]/remove",
    "/api/checkout/categories",
    "/api/checkout/gift-cards",
    "/api/checkout/items/[itemId]",
    "/api/checkout/lines/[lineId]/quantity/[quantity]",
    "/api/checkout/payment",
    "/api/checkout/payment-fields",
    "/api/checkout/payment-methods/[paymentMethodId]",
    "/api/checkout/payment-result",
    "/api/checkout/payment-return/[order_status]/[...targetUrl]",
    "/api/checkout/products",
    "/api/checkout/selection",
    "/api/checkout/shipping-methods/[shippingMethodId]",
    "/api/checkout/vouchers",
    "/api/checkout/vouchers/delete",
    "/api/health",
    "/api/marketing-subscriptions/confirm-doi-subscriber",
    "/api/marketing-subscriptions/customer/subscriber",
    "/api/marketing-subscriptions/subscriber",
    "/api/merch/notifications/payment",
    "/api/merch/notifications/payment.spec",
    "/api/products",
    "/api/products/index.spec",
    "/api/products/measurements",
    "/api/products/measurements.spec",
    "/api/products/[uri]/items",
    "/api/products/[uri]/items.spec",
    "/api/products/[uri]/related-products",
    "/api/products/[uri]/related-products.spec",
    "/api/public/storyblok/account-navigation-kind",
    "/api/public/storyblok/gap",
    "/api/public/storyblok/icons",
    "/api/public/storyblok/space",
    "/api/reviews",
    "/api/reviews/index.spec",
    "/api/reviews/summary",
    "/api/reviews/summary/index.spec",
    "/api/stores/by-country",
    "/api/stores/countries",
    "/api/stores/inventory",
    "/api/tracking/order-first-purchase",
    "/api/tracking/order-first-purchase.spec",
    "/auth-callback",
    "/[languageMarket]/confirm-subscriber",
    "/[languageMarket]/order-tracking",
    "/[languageMarket]/subscription",
    "/[languageMarket]/unsubscribe",
    "/[languageMarket]/[[...slug]]"
  ]
};self.__BUILD_MANIFEST_CB && self.__BUILD_MANIFEST_CB()